"use client";

import React, { useRef } from "react";
import {  Home, Coffee, MapPin, Plane, Globe } from "lucide-react"; 
import { motion } from "framer-motion";

export default function OurClientsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  const clientSegments = [
    {
      title: "Turismo",
      description:
        "Agências de viagens, consolidadoras e operadoras de turismo.",
      Icon: Plane,
    },
    {
      title: "Hospedagem e Lazer",
      description: "Rede hoteleira e parques temáticos.",
      Icon: Home,
    },
    {
      title: "Gastronomia e Entretenimento",
      description: "Restaurantes e demais empreendimentos gastronômicos.",
      Icon: Coffee,
    },
    {
      title: "Cidades e Empresas",
      description:
        "Destinos turísticos e empresas que desejam inovar em experiências e serviços premium.",
      Icon: MapPin,
    },
    {
      title: "Agências de intercâmbio",
      description:
        "Transformamos experiências de intercâmbio unindo educação, turismo e tecnologia.",
      Icon: Globe,
    },
  ];

  return (
    <section ref={sectionRef} className="py-20 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto text-center mb-12">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-blue-700 mb-2"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5 }}
        >
          Para quem são nossos serviços
        </motion.h2>
        <motion.p
          className="text-gray-600 text-base md:text-lg max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          Atendemos empresas e destinos que buscam inovação, excelência e
          experiências memoráveis. Nosso foco é transformar serviços de turismo
          e entretenimento em experiências premium, com o apoio da tecnologia e
          da Inteligência Artificial.
        </motion.p>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 max-w-7xl mx-auto">
        {clientSegments.map(({ title, description, Icon }, i) => (
          <motion.div
            key={i}
            className="flex flex-col items-center text-center p-4 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
          >
            <div className="h-12 w-12 flex items-center justify-center mb-3 text-blue-500">
              <Icon size={28} />
            </div>
            <h3 className="font-semibold text-lg text-gray-800">{title}</h3>
            <p className="text-gray-600 text-sm mt-1">{description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
